// import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

// export default {
//     GetAllGroupsForDropDown,
//     GetAllFactoriesByGroupID,
//     GetFarmerDetailsByFactoryIDRouteID,
// };

// async function GetAllGroupsForDropDown() {
//     const response = await CommonGet('/api/Group/GetAllGroups', null);
//     return response.data;
// }

// async function GetAllFactoriesByGroupID(groupID) {
//     const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
//     return response.data;
// }

// async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
//     const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
//     return response.data;
// }

/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetDetailsForCOPReport,
    GetExpenseDetailsbyFarmerActivityID,

    GetVCCFactoriesByGroupID,
    GetFarmerDetailsByMultipleFactoryID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFarmerDetailsByMultipleFactoryID(model) {
    const response = await CommonPost('/api/Farmer/GetFarmerDetailsByMultipleFactoryID', null, model);
    return response.data;
}

async function GetDetailsForCOPReport(model) {
    const response = await CommonPost('/api/COP/GetDetailsForCOPReport',null, model);
    return response.data;
}

async function GetExpenseDetailsbyFarmerActivityID(farmerActivityID) {
    const response = await CommonGet('/api/COP/GetExpenseDetailsbyFarmerActivityID', 'farmerActivityID=' + parseInt(farmerActivityID));
    return response.data;
}

